export const bibleNames = {
	Gen: "Genesis",
	Exod: "Exodus",
	Exo: "Exodus",
	exo: "Exodus",
	Ex: "Exodus",
	ex: "Exodus",
	Lev: "Leviticus",
	Num: "Numbers",
	Deut: "Deuteronomy",
	Deu: "Deuteronomy",
	Josh: "Joshua",
	Jos: "Joshua",
	Judg: "Judges",
	Jud: "Judges",
	"1 Sam": "1 Samuel",
	"2 Sam": "2 Samuel",
	"1 Kings": "1 Kings",
	"2 Kings": "2 Kings",
	"1 Chr": "1 Chronicles",
	"2 Chr": "2 Chronicles",
	"1 Chron": "1 Chronicles",
	"2 Chron": "2 Chronicles",
	"4 Es": "4 Esdras",
	"4 Esd": "4 Esdras",
	"4 es": "4 Esdras",
	"4 esd": "4 Esdras",

	Neh: "Nehemiah",
	Esth: "Esther",
	Est: "Esther",

	// Apocrypha / Deuterocanon
	Tobit: "Tobit",
	Judith: "Judith",
	"1 Maccabees": "1 Maccabees",
	"2 Maccabees": "2 Maccabees",
	Baruch: "Baruch",
	Sirach: "Sirach",

	Ps: "Psalms",
	Psa: "Psalms",
	Psalm: "Psalms",
	wis: "Wisdom",
	Wis: "Wisdom",
	Prov: "Proverbs",
	Pro: "Proverbs",
	Eccl: "Ecclesiastes",
	Ecc: "Ecclesiastes",
	Song: "Songs", // This is the filename Songs 1.html
	Sng: "Songs",
	Isa: "Isaiah",
	Is: "Isaiah",
	isa: "Isaiah",
	is: "Isaiah",
	Jer: "Jeremiah",
	Lam: "Lamentations",
	Ezek: "Ezekiel",
	Eze: "Ezekiel",
	Dan: "Daniel",
	Hos: "Hosea",
	Obad: "Obadiah",
	Oba: "Obadiah",
	Mic: "Micah",
	Nah: "Nahum",
	Hab: "Habakkuk",
	Zeph: "Zephaniah",
	Zep: "Zephaniah",
	Hag: "Haggai",
	Zech: "Zechariah",
	Zec: "Zechariah",
	Mal: "Malachi",
	Matt: "Matthew",
	Mat: "Matthew",
	Mar: "Mark",
	Luk: "Luke",
	luk: "Luke",
	luke: "Luke",
	john: "John",
	jn: "John",
	Jn: "John",
	acts: "Acts",
	Act: "Acts",
	Rom: "Romans",
	Roma: "Romans",
	roma: "Romans",
	rom: "Romans",
	ro: "Romans",
	"1 Cor": "1 Corinthians",
	"2 Cor": "2 Corinthians",
	Gal: "Galatians",
	Eph: "Ephesians",
	Phil: "Philippians",
	Phi: "Philippians",
	Col: "Colossians",
	"1 Thess": "1 Thessalonians",
	"2 Thess": "2 Thessalonians",
	"1 Thes": "1 Thessalonians",
	"2 Thes": "2 Thessalonians",
	"1 The": "1 Thessalonians",
	"2 The": "2 Thessalonians",
	"1 Tim": "1 Timothy",
	"2 Tim": "2 Timothy",
	Ti: "Titus",
	ti: "Titus",
	Tit: "Titus",
	Phlm: "Philemon",
	Phl: "Philemon",
	Heb: "Hebrews",
	Jas: "James",
	"1 Pet": "1 Peter",
	"2 Pet": "2 Peter",
	"1 John": "1 John",
	"2 John": "2 John",
	"3 John": "3 John",
	"1jn": "1 John",
	"2jn": "2 John",
	"3jn": "3 John",
	"1 jn": "1 John",
	"2 jn": "2 John",
	"3 jn": "3 John",
	Rev: "Revelation",
};

// Extra aliases that aren’t all present as keys above but should resolve to canonical names.
const extraAliases: Record<string, string> = {
	songofsolomon: "Songs",
	songofsongs: "Songs",
	songs: "Songs",
	song: "Songs",
	sos: "Songs",
	canticles: "Songs",
	psalms: "Psalms",
	psalm: "Psalms",
	psa: "Psalms",
	ps: "Psalms",
};

function safeDecodeURIComponent(input: string): string {
	try {
		return decodeURIComponent(input);
	} catch {
		return input;
	}
}

function normalizeAliasKey(input: string): string {
	return input
		.toLowerCase()
		.replace(/[%]/g, "") // remove stray percent signs if decode failed
		.replace(/[\s_.-]+/g, "") // drop separators
		.replace(/[^a-z0-9]/g, ""); // keep alphanumerics only
}

function buildAliasMap(): Record<string, string> {
	const map: Record<string, string> = {};

	// From bibleNames keys and values
	for (const [alias, canonical] of Object.entries(bibleNames)) {
		map[normalizeAliasKey(alias)] = canonical;
		map[normalizeAliasKey(canonical)] = canonical;
	}

	// From extraAliases
	for (const [alias, canonical] of Object.entries(extraAliases)) {
		map[normalizeAliasKey(alias)] = canonical;
	}

	return map;
}

const aliasMap = buildAliasMap();

// Legacy book_id -> canonical name (aligned to bibleNames canonical spellings)
export const bookIdToName: Record<number, string> = {
	1: "Genesis",
	2: "Exodus",
	3: "Leviticus",
	4: "Numbers",
	5: "Deuteronomy",
	6: "Joshua",
	7: "Judges",
	8: "Ruth",
	9: "1 Samuel",
	10: "2 Samuel",
	11: "1 Kings",
	12: "2 Kings",
	13: "1 Chronicles",
	14: "2 Chronicles",
	15: "Ezra",
	16: "Nehemiah",
	17: "Tobit",
	18: "Judith",
	19: "Esther",
	20: "1 Maccabees",
	21: "2 Maccabees",
	22: "Job",
	23: "Psalms",
	24: "Proverbs",
	25: "Ecclesiastes",
	26: "Songs", // canonical filename in this project
	27: "Wisdom",
	28: "Sirach",
	29: "Isaiah",
	30: "Jeremiah",
	31: "Lamentations",
	32: "Baruch",
	33: "Ezekiel",
	34: "Daniel",
	35: "Hosea",
	36: "Joel",
	37: "Amos",
	38: "Obadiah",
	39: "Jonah",
	40: "Micah",
	41: "Nahum",
	42: "Habakkuk",
	43: "Zephaniah",
	44: "Haggai",
	45: "Zechariah",
	46: "Malachi",
	47: "Matthew",
	48: "Mark",
	49: "Luke",
	50: "John",
	51: "Acts",
	52: "Romans",
	53: "1 Corinthians",
	54: "2 Corinthians",
	55: "Galatians",
	56: "Ephesians",
	57: "Philippians",
	58: "Colossians",
	59: "1 Thessalonians",
	60: "2 Thessalonians",
	61: "1 Timothy",
	62: "2 Timothy",
	63: "Titus",
	64: "Philemon",
	65: "Hebrews",
	66: "James",
	67: "1 Peter",
	68: "2 Peter",
	69: "1 John",
	70: "2 John",
	71: "3 John",
	72: "Jude",
	73: "Revelation",
};

export function resolveBookId(bookId: string | number): string | undefined {
	const numeric = Number(bookId);
	if (Number.isNaN(numeric)) return undefined;
	const canonical = bookIdToName[numeric];
	if (!canonical) return undefined;
	return resolveBookName(canonical);
}

/**
 * Levenshtein distance for suggestion ranking.
 */
function levenshtein(a: string, b: string): number {
	const m = a.length;
	const n = b.length;

	// Early exits
	if (m === 0) return n;
	if (n === 0) return m;

	const dp: number[][] = Array.from({ length: m + 1 }, () =>
		new Array(n + 1).fill(0),
	);
	for (let i = 0; i <= m; i++) dp[i][0] = i;
	for (let j = 0; j <= n; j++) dp[0][j] = j;

	for (let i = 1; i <= m; i++) {
		for (let j = 1; j <= n; j++) {
			const cost = a[i - 1] === b[j - 1] ? 0 : 1;
			dp[i][j] = Math.min(
				dp[i - 1][j] + 1, // deletion
				dp[i][j - 1] + 1, // insertion
				dp[i - 1][j - 1] + cost, // substitution
			);
		}
	}

	return dp[m][n];
}

/**
 * Build a unique list of canonical book names from the alias map.
 */
const canonicalBooks = Array.from(new Set(Object.values(aliasMap)));

/**
 * Normalize + exact alias match (no fuzzy/Levenshtein here).
 * Examples:
 *  - "psa%2015" -> "Psalms 15"
 *  - "Psa 15"   -> "Psalms 15"
 *  - "1John2"   -> "1 John 2"
 *  - "song"     -> "Songs"
 *  - "song 1"   -> "Songs 1"
 *
 * @param bookname Raw input book name (may include chapter/verse numbers)
 * @param _legacyBibleNames Back-compat; ignored since aliasMap is internal
 */
export function resolveBookName(
	bookname: string,
	_legacyBibleNames?: { [key: string]: string },
): string {
	// 1) Decode and trim
	const decoded = safeDecodeURIComponent(bookname).trim();

	// 2) Tokenize (letters and numbers)
	const tokens = decoded.match(/[a-zA-Z]+|\d+/g) ?? [];

	// If last token is numeric, treat it as chapter; everything before is book
	let chapter: string | undefined;
	if (tokens.length > 1 && /^\d+$/.test(tokens[tokens.length - 1])) {
		chapter = tokens.pop();
	}

	// Book part is remaining tokens; if none, fall back to decoded input
	const bookPart = tokens.length ? tokens.join(" ") : decoded;
	const normalizedBook = normalizeAliasKey(bookPart);

	const canonicalBook = aliasMap[normalizedBook];
	if (!canonicalBook) {
		// No match; return original input unchanged
		return bookname;
	}

	return chapter ? `${canonicalBook} ${chapter}` : canonicalBook;
}

/**
 * Suggestion-enabled resolution:
 * - If an exact match exists, returns { resolved, suggestions: [] }.
 * - If no exact match, resolved is original input; suggestions is a ranked list (by edit distance)
 *   of likely canonical books (optionally suffixed with the parsed chapter).
 *
 * @param bookname Raw input book name (may include chapter/verse numbers)
 * @param maxSuggestions Maximum number of suggestions to return (default 3)
 */
export function resolveBookNameWithSuggestions(
	bookname: string,
	maxSuggestions = 3,
): { resolved: string; suggestions: string[] } {
	// 1) Decode and trim
	const decoded = safeDecodeURIComponent(bookname).trim();

	// 2) Tokenize (letters and numbers)
	const tokens = decoded.match(/[a-zA-Z]+|\d+/g) ?? [];

	// If last token is numeric, treat it as chapter; everything before is book
	let chapter: string | undefined;
	if (tokens.length > 1 && /^\d+$/.test(tokens[tokens.length - 1])) {
		chapter = tokens.pop();
	}

	// Book part is remaining tokens; if none, fall back to decoded input
	const bookPart = tokens.length ? tokens.join(" ") : decoded;
	const normalizedBook = normalizeAliasKey(bookPart);

	const canonicalBook = aliasMap[normalizedBook];
	if (canonicalBook) {
		return {
			resolved: chapter ? `${canonicalBook} ${chapter}` : canonicalBook,
			suggestions: [],
		};
	}

	// No exact match: rank suggestions by Levenshtein distance against canonical names
	const scored = canonicalBooks.map((canonical) => {
		const normCanonical = normalizeAliasKey(canonical);
		return {
			canonical,
			distance: levenshtein(normalizedBook, normCanonical),
		};
	});

	scored.sort((a, b) => a.distance - b.distance);

	const suggestions = scored
		.slice(0, Math.max(0, maxSuggestions))
		.map(({ canonical }) => (chapter ? `${canonical} ${chapter}` : canonical));

	return {
		resolved: bookname,
		suggestions,
	};
}
